import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'numberTextFieldPlaceholderMessage'
  | 'emailTextFieldPlaceholderMessage'
  | 'textFieldPlaceholderMessage'
  | 'multilineTextFieldPlaceholderMessage';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  numberTextFieldPlaceholderMessage: {
    id: 'boxFileRequest.numberTextField.placeholderMessage',
    description: 'Placeholder for number text field',
    defaultMessage: 'Enter a number',
  },
  emailTextFieldPlaceholderMessage: {
    id: 'boxFileRequest.emailTextField.placeholderMessage',
    description: 'Placeholder for email text field',
    defaultMessage: 'Enter your email',
  },
  textFieldPlaceholderMessage: {
    id: 'boxFileRequest.textField.placeholderMessage',
    description: 'Placeholder for text field',
    defaultMessage: 'Enter a response',
  },
  multilineTextFieldPlaceholderMessage: {
    id: 'boxFileRequest.multilineTextField.placeholderMessage',
    description: 'Placeholder for multiline text field',
    defaultMessage: 'Enter a response',
  },
});

export default messages;
